export default function CalendarHero() {
  return (
    <section className="relative bg-foreground-950 pt-28 md:pt-40 pb-12 md:pb-20 px-4 md:px-8 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Wide%20aerial%20view%20of%20a%20deep%20green%20golf%20course%20at%20dawn%20with%20early%20morning%20mist%20over%20fairways%20and%20bunkers%2C%20strong%20dark%20edges%20for%20text%20contrast%2C%20cinematic%20sports%20broadcast%20style%2C%20moody%20atmospheric%20tones%2C%20no%20people%20no%20logos&width=1920&height=1080&seq=gs-cal-hero&orientation=landscape"
        alt="Golf course fairways at dawn"
        title="GreenSide News event calendar"
        className="absolute inset-0 w-full h-full object-cover object-top opacity-40"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/70 to-foreground-950/40"></div>
      <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
        <div className="lg:col-span-8">
          <p className="gs-rise font-label uppercase tracking-[0.25em] text-sm text-accent-400 font-bold">Calendar</p>
          <h1 className="gs-rise-2 font-heading font-extrabold uppercase text-background-50 text-5xl md:text-7xl lg:text-8xl leading-[0.9] tracking-tight mt-2">
            Every local tournament, in one place.
          </h1>
          <p className="gs-rise-3 mt-5 text-background-200 text-base md:text-lg max-w-2xl">
            Charity, women&apos;s and club golf across Long Beach and neighboring cities. Grouped by month, updated as dates are confirmed.
          </p>
        </div>
        <div className="lg:col-span-4 flex lg:justify-end">
          <a href="#list-event" className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-400 text-foreground-950 font-label font-bold uppercase tracking-wider px-5 py-3 rounded-md whitespace-nowrap cursor-pointer">
            <span className="w-5 h-5 flex items-center justify-center"><i className="ri-add-line"></i></span>List your event free
          </a>
        </div>
      </div>
    </section>
  );
}